/// <reference path="../../../node_modules/@types/jquery/index.d.ts" />
/// <reference path="../../../node_modules/@types/jqueryui/index.d.ts" />
/// <reference path="../shared/jquery.extension.d.ts" />
/// <reference path="../shared/foundation.d.ts" />

import { HttpClient } from '@angular/common/http';
import { Observable, BehaviorSubject, Subject } from 'rxjs';
import { ElementRef, Injectable } from '@angular/core';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { AccessControlMenu } from '../models/access-control-menu.model';
import { UserAccessMenu } from '../models/user-access-menu.model';
import { AccessMenuViewModel } from '../models/AccessMenuViewModel';
import { ApiResponse } from '../models/api-response.model';
import { Validators } from '@angular/forms';
// import { ToastData, ToastOptions, ToastyService } from 'ng2-toasty';
import { IMenu } from '../models/imenu.model';
import { Router } from '@angular/router';
import { ToastComponent } from '../shared/toast/toast.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { HardwareDeviceReportModel, HardwareReadinessModel, WindowsFeatureModel, WorkFromAnywhereModel } from '../models/Windows11Readiness.model';

@Injectable()
export class CommonService {
    analyticsImpression = 'I';
    analyticsClick = 'C';
    step = '';

    public updateLocation: Subject<any> = new Subject<any>();

    constructor(
        private http: HttpClient,
        private authService: AuthService,
        private snackBar: MatSnackBar,
        private router: Router
    ) {
    }

    private watchStepSubject = new BehaviorSubject<string>(this.step);
    currentStep = this.watchStepSubject.asObservable();
    private updateSideBarActiveItem = new BehaviorSubject<string>("");
    updateSideBarActiveItem$ = this.updateSideBarActiveItem.asObservable();
    NoMPNText = 'No Indirect Reseller';
    // private dataSubject = new BehaviorSubject<any[]>([]);

    // private windowsFeatureSubject = new BehaviorSubject<WindowsFeatureModel[] | null>(null);
    // private workAnywhereSubject = new BehaviorSubject<WorkFromAnywhereModel[] | null>(null);
    // private hardwareReadinessSubject = new BehaviorSubject<HardwareDeviceReportModel[] | null>(null);
    // win11ModelType$ = new BehaviorSubject<'workFromAnywhere' | 'windowsFeature' | 'hardwareReadiness' | null>(null);
    // private allDevicesUpgradedToWin11Subject = new BehaviorSubject<boolean>(false);
    // allDevicesUpgradedToWin11$ = this.allDevicesUpgradedToWin11Subject.asObservable();

    // windowsFeature$ = this.windowsFeatureSubject.asObservable();
    // workAnywhere$ = this.workAnywhereSubject.asObservable();
    // hardwareReadiness$ = this.hardwareReadinessSubject.asObservable();

    getIsDevOps(): Boolean {
        var currentUser = this.authService.currentUserModel;
        var users = this.getCookieValue('dd-do-cookie');
        users = decodeURIComponent(users);
        users = atob(users);
        return (!currentUser.isImpersonated && users.includes(currentUser.email));
    }


    parseNPM(npmText: string) {
        let mpn = '';
        if (npmText !== this.NoMPNText){
            mpn = npmText;
        }
        return mpn;
    }

    showError = (
        selector: string,
        message: string,
        position: 'top' | 'right' | 'bottom' | 'left',
    ) => {
        this.showValidator(selector, message, position, 'error', true, true);
    }

    showSuccess = (
        selector: string,
        message: string,
        position: 'top' | 'right' | 'bottom' | 'left',
    ) => {
        this.showValidator(selector, message, position, 'success', true, false);
    }

    showResult = (
        selector: string,
        message: string,
        position: 'top' | 'right' | 'bottom' | 'left',
        finishTime?: number
    ) => {
        finishTime = finishTime || 1000;
        this.showValidator(selector, message, position, 'success', true, false, finishTime);
    }

    showConfirm = (
        selector: string,
        message: string,
        position: 'top' | 'right' | 'bottom' | 'left',
        confirmCallback: Function
    ) => {
        this.showValidator(selector, message, position, 'confirm', true, false, 1000, confirmCallback);
    }

    showValidator = (
        selector: string,
        message: string,
        position: 'top' | 'right' | 'bottom' | 'left',
        messageType: 'success' | 'error' | 'confirm' | 'warning',
        isStayOut: boolean = false,
        isStayAlive: boolean = false,
        finishTime?: number,
        confirmCallback?: Function,
        confirmOptions?: string[],
        confirmTheme?: string
    ) => {
        $(selector).showValidator(message, messageType, position, isStayOut, isStayAlive, finishTime, confirmCallback, confirmTheme, confirmOptions);
    }

    //#endregion
    emailValidatorRegex = () => {
        return Validators.compose([Validators.required, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')])
    }

    elevateZoomService = (
        selector: string,
        tint: boolean,
        tintColour: string,
        tintOpacity: number,
        easing: boolean,
        scrollZoom: boolean,
        zoomWindowWidth: number,
        zoomWindowHeight: number,
        cursor: string
    ) => {
        $(selector).elevateZoom(tint, tintColour, tintOpacity, easing, scrollZoom, zoomWindowWidth, zoomWindowHeight, cursor);
    }

    foundationService = (
        method?: string | Array<any>,
        $element?: JQuery
    ) => {
        $(document).foundation(method, $element);
    }


    savecookies(name: string, value: string, days: number) {
        this.createCookie(name, value, days);
    }

    createCookie(name: string, value: string, days: number) {
        let expires = '';
        if (days) {
            const date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = '; expires=' + date.toUTCString();
        }
        console.log(name + '=' + value + expires + '; path=/')
        document.cookie = name + '=' + value + expires + '; path=/';
    }

    readCookie(name: string) {
        const nameEQ = name + '=';
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1, c.length);
            }
            if (c.indexOf(nameEQ) === 0) {
                return c.substring(nameEQ.length, c.length);
            }
        }
        return null;
    }
    getCookieValue(name) 
    {
      const regex = new RegExp(`(^| )${name}=([^;]+)`)
      const match = document.cookie.match(regex)
      if (match) {
        return match[2]
      }
      return null
   }

    // banner locations
    getBannerLocationId(location: string) {
        let locationId = 0;
        switch (location) {
            case 'buy':
                locationId = 1;
                break;
            case 'searchresult':
                locationId = 2;
                break;
            case 'order':
                locationId = 3;
                break;
            case 'oldwebsite':
                locationId = 4;
                break;
            case 'cart':
                locationId = 5;
                break;
            case 'finance':
                locationId = 6;
                break;
            case 'quote':
                locationId = 7;
                break;
            case 'quotedownload':
                locationId = 8;
                break;
            case 'event':
                locationId = 9;
            break;
        }
        return locationId;
    }

    getAnalyticsType(type: string) {
        let analyticsType = '';
        switch (type) {
            case 'impression':
                analyticsType = 'I';
                break;
            case 'click':
                analyticsType = 'C';
                break;
        }
        return analyticsType;
    }

    // upload Files and images
    uploadCloudResource(id, type, file, actionType = 'I') {
        const input = new FormData();
        input.append('file', file);
        return this.http.post('api/services/UpdateCloudResource?id=' + id + '&actionType=' + actionType + '&type=' + type, input)
            .pipe(map((res: any) => res), catchError(this.authService.handleError));
    }

    deleteCloudResource(id) {
        const input = new FormData();
        return this.http.post('api/services/DeleteCloudResource?id=' + id, input).pipe(map((res: any) => res), catchError(this.authService.handleError));
    }

    // upload Files and images
    getAccessMenuList(): Observable<Array<AccessControlMenu>> {
        return this.http.get<AccessControlMenu>('api/values/GetAccessControlMenu').pipe(map((res: any) => res), catchError(this.authService.handleError));
    }

    getUserByMenu(accountId?: string, menuId?: number): Observable<Array<UserAccessMenu>> {
        return this.http.get<Array<UserAccessMenu>>('api/values/GetUserByMenu?accountId=' + accountId + '&menuId=' + menuId)
            .pipe(catchError(this.authService.handleError));
    }

    getUserMenu(accountId?: string, userId?: string): Observable<Array<UserAccessMenu>> {
        return this.http.get<UserAccessMenu>('api/values/GetUserMenu?accountId=' + accountId + '&userId=' + userId).pipe(map((res: any) => res), catchError(this.authService.handleError));
    }

    getLoggedInUserMenu(): Observable<Array<UserAccessMenu>> {
        return this.http.get<UserAccessMenu>('api/values/GetLoggedInUserMenu').pipe(map((res: any) => res), catchError(this.authService.handleError));
    }

    saveUserAccessMenu(accessControl: Array<AccessMenuViewModel>): Observable<boolean> {
        return this.http.post<boolean>('api/values/SaveUserAccessMenu', accessControl)
            .pipe(catchError(this.authService.handleError));
    }

    deleteUserAccessMenu(accessControl: Array<AccessMenuViewModel>): Observable<boolean> {
        return this.http.post<boolean>('api/values/DeleteUserAccessMenu', accessControl)
            .pipe(catchError(this.authService.handleError));
    }

    monitorStepChange(step: string): void {
        this.watchStepSubject.next(step);
    }

    hasFinanceQuote(): Observable<ApiResponse> {
        return this.http.get<ApiResponse>('/HasFinanceQuote').pipe(map((res: any) => res), catchError(this.authService.handleError));
    }

    getHomeMenu(): Observable<IMenu[]> {
        return this.http.get<IMenu[]>('/GetHomeMenu').pipe(catchError(this.authService.handleError));
    }    
    
    getWarehouseList(): Observable<any> {
        return this.http
            .get<any>('/GetWarehouseLocationList')
            .pipe(catchError(err => {
                this.authService.handleError;
                throw err;
            }));    
    }

    getHandsontableLicenseKey(): Observable<string> {
        return this.http.get('/GetHandsontableLicense', { responseType: 'text' }).pipe(catchError(this.authService.handleError));
    }

    // date string function
    getDateString = (date: Date): string => {
        let dateStr = '';
        const dd = date.getDate();
        const mm = date.getMonth() + 1; // January is 0!
        const yyyy = date.getFullYear();

        if (dd < 10) {
            dateStr += '0';
        }
        dateStr += dd + '-';
        if (mm < 10) {
            dateStr += '0';
        }
        dateStr += mm + '-';
        dateStr += yyyy;

        return dateStr;
    }

    // dd date format 'dd-MMM-yyy' e.g. '01-JAN-2022'
    // some browser based issue(Firefox) can not do: new Date('01-JAN-2022'), so we need to manually get value from it
    getValueFromDDDate = (ddDate: string): any => {
        const months = {
            'JAN': 1,
            'FEB': 2,
            'MAR': 3,
            'APR': 4,
            'MAY': 5,
            'JUN': 6,
            'JUL': 7,
            'AUG': 8,
            'SEP': 9,
            'OCT': 10,
            'NOV': 11,
            'DEC': 12
        };
        const values = ddDate.split('-')
        return { year: parseInt(values[2]), month: months[values[1]], day: parseInt(values[0])}
    }

    implementToast = (msg: string, type: 'Success' | 'Error' | 'Info' | 'Warning', noDismiss: boolean = false) => {
        noDismiss = type ==  'Error';
        console.log('Toast: ', msg, type, noDismiss);
        this.snackBar.openFromComponent(ToastComponent,
              {
                  duration: noDismiss ? 100000000000 : 3000,
                  data: { message: msg, type: type },
                  horizontalPosition: 'right',
                  verticalPosition: 'top',
                  panelClass: type + 'Toast'
              });
        // let toastIcon = '';
        // switch (type) {
        //     case 'Success':
        //         toastIcon = '<i class="fas fa-check-circle" style="font-size: 1.9em; background: radial-gradient(white 65%, transparent 0%); color: #C20047;"></i>';
        //         break;
        //     case 'Error':
        //         toastIcon = '<i class="fa fa-times-circle" style="font-size: 2em; background: radial-gradient(white 55%, transparent 0%); color: #C20047;"></i>';
        //         break;
        //     case 'Info':
        //         toastIcon = '<i class="fas fa-info-circle" style="font-size: 2em; background: radial-gradient(white 55%, transparent 0%); color: #C20047;"></i>';
        //         break;
        //     case 'Warning':
        //         toastIcon = '<i class="fas fa-exclamation-circle" style="font-size: 2em; background: radial-gradient(white 55%, transparent 0%); color: #C20047;"></i>';
        //         break;
        // }

        // const htmltext = `
        //     <div class="toast" style="box-shadow: none;">
        //         <div class="toast-icon">
        //             ${ toastIcon }
        //         </div>
        //     <div class="toast-message">
        //         <div class="toast-custom-title">
        //             ${ type }
        //         </div>
        //         <div id="toast-content" class="toast-content">
        //             ${ msg }
        //         </div>
        //     </div>
        // `;

        // // Or create the instance of ToastOptions
        // var toastOptions:ToastOptions = {
        //     title: type,
        //     msg: htmltext,
        //     showClose: true,
        //     timeout: type === 'Error' ? 999999999 : (noDismiss ? 6000 : 3000),
        //     theme: "material",
        //     onAdd: (toast:ToastData) => {
        //         // console.log('Toast ' + toast.id + ' has been added!');
        //     },
        //     onRemove: function(toast:ToastData) {
        //         // console.log('Toast ' + toast.id + ' has been removed!');
        //     }
        // };

        // this.toastyService.default(toastOptions);
    }

    // Current or Max Quantity calculation
    showWebMaxQty(current: string, max: string): string {
        //debugger;
        const qty = parseInt(current);
        if (qty > 0) {
            return (parseInt(current) >= parseInt(max) && parseInt(max) > 0) ? parseInt(max).toFixed(0) + '+' : parseInt(current).toFixed(0);
        } else {
            return parseInt(current).toFixed(0);            
        }
    }

    // Used by MS Perp/AzureRI/SS
    validateCustomerRef(event: any): void {
        const pattern: RegExp = /[!@#$%^&*(),.?":{}|<>\s]/g;
        if (event.inputType === 'insertText') {
            // let inputChar = String.fromCharCode(event.data);
            if (pattern.test(event.data)) {
                // invalid character, prevent input
                event.target.value = event.target.value.replace(pattern, '');
            }
        } else if (event.inputType === 'insertFromPaste') {
            if (pattern.test(event.target.value)) {
                // invalid input added from Paste
                event.target.value = event.target.value.replace(pattern, '');
            }
        }
    }

    // Used for subscription reference validation
    subscription_customer_ref_validation(event, inputName?) {
        let lenLimit = 30
        if (inputName == 'wgsPORef') {
            lenLimit = 20;
        }
        if (event.target.value.match(/\//g)) {
            event.target.value = event.target.value.replace(/\//g, '');
            this.implementToast('The slash character is not allowed', 'Error');
        }
        if (event.target.value.length >= lenLimit) {
            this.implementToast(`The max length of the PoReference is ${lenLimit} characters`, 'Error');
        }
    }

    checkPasswordValidation(password) {
        // const pattern = /^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z])(?=.*[!@#$%^&*()_+])[0-9a-zA-Z!@#$%^&*()_+]{8,20}$/;
        // if (password && password.match(pattern)) {
        //     return true;
        // } else {
        //     return false;
        // }
        // console.log(password);
        const hasUpper = /[A-Z]/.test(password) ? 1 : 0;
        const hasLower = /[a-z]/.test(password) ? 1 : 0;
        const hasNumbers = /\d/.test(password) ? 1 : 0;
        const hasSpecial = /[!@#$%^&*]/.test(password) ? 1 : 0;
        const lengthMatch = (password.length < 8 || password.length > 20) ? false : true;
        const passwordMatchThreeTypes = (hasUpper + hasLower + hasNumbers + hasSpecial < 3) ? false : true;
        const passwordIsValidated = (lengthMatch && passwordMatchThreeTypes) ? true : false;
        const checkPasswordStatus = {
            hasUpper: hasUpper,
            hasLower: hasLower,
            hasNumbers: hasNumbers,
            hasSpecial: hasSpecial,
            lengthMatch: lengthMatch,
            passwordMatchThreeTypes: passwordMatchThreeTypes,
            passwordIsValidated: passwordIsValidated
        };
        // if (hasUpper + hasLower + hasNumbers + hasSpecial < 3) {
        //     return false;
        // } else if(password.length < 8 || password.length > 20) {
        //     return false;
        // } else {
        //     return true;
        // }
        return checkPasswordStatus;
    }

    // check if valid URL
    checkIfValidUrl(url) {
        const pattern = /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?/;
        if (pattern.test(url)) {
            return true;
        } else {
            return false;
        }
    }

    getFileFromUrl(fileUrl: string): Observable<string> {
        // let headers =  {headers: new  HttpHeaders({ 'Content-Type': 'text/plain'})};

        return this.http.get(fileUrl, { responseType: 'text' }).pipe(catchError(this.authService.handleError));
    }

    emitUpdateSideBarActiveItem(menuId: string) {
        this.updateSideBarActiveItem.next(menuId);
    }

    applyScrollFixedHeader(parentWrapper: ElementRef) {
        if (typeof parentWrapper == "object") {
            const parentElm = parentWrapper.nativeElement;
            parentElm.addEventListener("scroll", this.onScroll);
            setTimeout(() => {
                let tableElms = parentElm.querySelectorAll('.mTable');
                let tableHeaderElms = parentElm.querySelectorAll('.mTable-header');
                if (parentElm && tableElms && tableHeaderElms) {
                    for (let i = 0; i < tableElms.length; i++) {
                        let tableElm = tableElms[i];
                        let tableHeaderElm = tableHeaderElms[i];
                        if (!tableHeaderElm) {
                            tableHeaderElm = tableElm.cloneNode(true);
                            tableHeaderElm.innerHTML = '';
                            tableHeaderElm.classList.remove("mTable");
                            tableHeaderElm.classList.add("mTable-header");
                            tableElm.parentNode.insertBefore(tableHeaderElm, tableElm);
                        }
                        // if(tableHeaderElm.querySelector('table')) {
                        //     tableHeaderElm.removeChild(tableHeaderElm.querySelector('table'));
                        // }
                        this.appendFixedHeader(tableElm, tableHeaderElm);
                    }
                }
            }, 100)
        }
    }

    onScroll(event: any) {
        const parentElm = event.target;
        const tableElms = parentElm.querySelectorAll('.mTable');
        const tableHeaderElms = parentElm.querySelectorAll('.mTable-header');
        if (parentElm && tableElms && tableHeaderElms) {
            for (let i = 0; i < tableElms.length; i++) {
                let tableElm = tableElms[i];
                let tableHeaderElm = tableHeaderElms[i];
                const parentTop = parentElm.getBoundingClientRect().top;
                const headerHeight = tableHeaderElm.offsetHeight;
                let tableTop = tableElm.getBoundingClientRect().top;
                if (tableTop - (parentTop + headerHeight) <= 0) {
                    tableHeaderElm.classList.add("fixedTableHeader");
                } else {
                    tableHeaderElm.classList.remove("fixedTableHeader");
                }
            }
        }
    }

    appendFixedHeader(mTable: any, mTableHeader: any) {
        if (!mTableHeader.querySelector('table') && mTable.querySelector('table thead')) {
            const tableHeader = mTable.querySelector('table').cloneNode(true);
            tableHeader.classList.add("table-header-allign");
            tableHeader.removeChild(tableHeader.querySelector('tbody'));
            if (tableHeader.querySelector('tfoot')) {
                tableHeader.removeChild(tableHeader.querySelector('tfoot'));
            }

            const fromTableHeader = mTable.querySelector('thead');
            const fromTHs = fromTableHeader.querySelectorAll("tr th");

            const toTableHeader = tableHeader.querySelector('thead');
            const toTHs = toTableHeader.querySelectorAll("tr th");

            fromTHs.forEach((element: any, index: number) => {
                if (element.clientWidth > 0) {
                    toTHs[index].style.width = element.clientWidth + "px";
                }
            });
            mTableHeader.appendChild(tableHeader);
            mTable.querySelector('thead').style.visibility = "collapse";
            mTableHeader.querySelector('thead').style.visibility = "unset";
        } else {
            const mTableHeaderTable = mTableHeader.querySelector('table');
            mTableHeaderTable.classList.add("table-header-allign");
            const fromTableHeader = mTable.querySelector('thead');
            const fromTHs = fromTableHeader.querySelectorAll("tr th");

            const toTableHeader = mTable.querySelector('table thead').cloneNode(true);
            const toTHs = toTableHeader.querySelectorAll("tr th");

            fromTHs.forEach((element: any, index: number) => {
                if (element.clientWidth > 0) {
                    toTHs[index].style.width = element.clientWidth + "px";
                }
            });
            mTable.querySelector('thead').style.visibility = "collapse";
        }
    }

    getNumnerOfDaysInCurrentMonth() {
        var dt = new Date();
        var month = dt.getMonth();
        month += 1;
        var year = dt.getFullYear();
        var daysInMonth = new Date(year, month, 0).getDate();
        return daysInMonth;
    }

    getDateDiffInDays(startDate: Date, endDate: Date) {
        var difference_In_Time = Math.abs(endDate.getTime() - startDate.getTime());
        var difference_In_Days = Math.ceil(difference_In_Time / (1000 * 3600 * 24));
        return difference_In_Days;
    }

    getDateDiffInHours(startDate: Date, endDate: Date) {
        var difference_In_Time = Math.abs(endDate.getTime() - startDate.getTime());
        var difference_In_Hours = Math.ceil(difference_In_Time / (1000 * 3600));
        return difference_In_Hours;
    }

    IsDatesInSameMonth(date1: Date, date2: Date){
        var month1 = date1.getMonth() + 1;
        var month2 = date2.getMonth() + 1;

        return (month1 === month2);
    }

    // _.isEmpty replacement
    isEmpty = passedObj => !(
        (passedObj && passedObj === Object(passedObj) && Object.keys(passedObj).length !== 0)
    )

    /**
     *  Sometimes we want to wait a DOM element is fully loaded first
     * 
     * @param selector 
     * @returns loaded element
     */
    public waitForElm(selector: string): Promise<Element>{
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
    
            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });
    
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    /**
     * !!! This function should only used for angular routing navigation purpose,
     * do not use for normal encode process 
     */
    public DDskuEncode(url: string): string {
        // Replace all occurrences of "+" with " "
        let encoding = url.replace(/\+/g, "^");
        // Encode the rest of the string using encodeURIComponent
        encoding = encodeURIComponent(encoding);
        return encoding;
    }

    /**
     * !!! This function should only used for angular routing navigation purpose,
     * do not use for normal encode process 
     */
    public DDskuDecode(url: string): string {
        // Decode the rest of the string using decodeURIComponent
        let decoding = decodeURIComponent(url);
        // Replace all occurrences of " " with "+"
        decoding = decoding.replace(/\^/g, "+");
        return decoding;
      }
    
    public manuallyEncodingBrackets(sku: string): string {
        let encodingOpenBracket = sku.replace(/\(/g, "%28");
        let encodingCloseBracket = encodingOpenBracket.replace(/\)/g, "%29");
        return encodingCloseBracket;
    }
    public isLeapYear(year: number): boolean {
        return ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
    }

    public ignoreLeapYearDay(): boolean {
        const today = new Date()
        const year = today.getFullYear()
        const month = today.getMonth()
        const isLeap = ((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0);
        return isLeap ? (month <= 1 ? false : true): true ;

    }

    public omit_nonprintable_char(nonprintchar: string): string { 
        let omit_nonprintable_char = nonprintchar.replace(/[^ -~]+/g, "").replace(/\\t/g, '').replace(/\\n/g, '');   
        return omit_nonprintable_char;
    }

    // converts DD-MM-YYYY to date object
    public getDate(dateString: string): Date {
        const dateParts = dateString?.split("-");
        return dateParts ? new Date(+dateParts[2], +dateParts[1] - 1, +dateParts[0]) : null
    }

    public parseToBillingCyleType(billingCycle: string): number {
        switch (billingCycle.toLocaleLowerCase()) {
          case 'monthly':
            return 1;
          case 'annual':
            return 2;
          case 'none':
            return 3;
          case 'onetime':
            return 4;
          case 'triennial':
            return 5;
          default:
            return 0;
        }
    }

    public getTermDisplay(termCode: string): string {
        switch (termCode) {
          case 'P1M':
            return 'Monthly'
          case 'P1Y':
            return 'Yearly'
          default:
            return ''
        }
    }

    public currencyRounding(n: number) : number {
        return Math.round(n * 100) / 100
    }

    // _.toNumber equivalent
    public toNumber(value: any): number {
        if (value === null || value === undefined) {
            return NaN;
        }
        
        const num = Number(value);
        return isNaN(num) ? NaN : num;
    }

    // _.toInteger equivalent
    public toInteger(value: any): number {
        if (value === null || value === undefined) {
          return 0;
        }
      
        const num = Number(value);
        return Math.trunc(num);
    }

    // _.random equivalent
    public random(min: number, max: number): number {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    // _.set equivalent
    public set(object: any, path: string[], value: any): any {
        let currentObject = object;
      
        path.forEach((key, index) => {
          if (index === path.length - 1) {
            currentObject[key] = value;
          } else {
            if (!currentObject[key]) {
              currentObject[key] = {};
            }
            currentObject = currentObject[key];
          }
        });
      
        return object;
    }

    // _.orderBy equivalent
    public orderBy(array: any[], iteratees: ((item: any) => any)[], orders: ('asc' | 'desc')[]): any[] {
        return array.sort((a, b) => {
          for (let i = 0; i < iteratees.length; i++) {
            const compareA = iteratees[i](a);
            const compareB = iteratees[i](b);
            const order = orders[i];
      
            if (compareA < compareB) {
              return order === 'asc' ? -1 : 1;
            } else if (compareA > compareB) {
              return order === 'asc' ? 1 : -1;
            }
          }
      
          return 0;
        });
    }

    // _.isNil equivalent
    public isNil(value: any): boolean {
        return value === null || value === undefined;
    }

    // _.groupBy equivalent
    public groupBy(arr, criteria) {
        return arr.reduce(function (obj, item) {
    
            // Check if the criteria is a function to run on the item or a property of it
            var key = typeof criteria === 'function' ? criteria(item) : item[criteria];
    
            // If the key doesn't exist yet, create it
            if (!obj.hasOwnProperty(key)) {
                obj[key] = [];
            }
    
            // Push the value to the object
            obj[key].push(item);
    
            // Return the object to the next item in the loop
            return obj;
    
        }, {});
    };


     // _.round equivalent
    public round(number: number, decimals: number): number {
        const multiplier = Math.pow(10, decimals);
        return Math.round(number * multiplier) / multiplier;
    }

    public isInCustiomerMenu(): boolean {
        return this.router.url.includes('customers');
    }

    public getPDTDate(): Date | null {
        try {
          const now: Date = new Date();
          const options: Intl.DateTimeFormatOptions = {
            timeZone: "America/Los_Angeles",
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            second: 'numeric',
            hour12: false, // Use 24-hour format for parsing
          };
      
          const pdtString: string = now.toLocaleString('en-US', options);
          return new Date(pdtString + " UTC"); // Important: Append "UTC" to avoid local timezone interpretation
        } catch (error) {
          console.error("Error getting PDT Date:", error);
          return null;
        }
    }

    public extractCSPSKUYearNumber(str: string): number | null {
        const regex = /^P(\d)Y:/;
        const match = str.match(regex);
      
        if (match) {
          return parseInt(match[1], 10);
        } else {
          return null;
        }
    }

    private createWordMapper(mapping) {
        const reverseMapping = {};
        for (const key in mapping) {
          reverseMapping[mapping[key]] = key;
        }
      
        return {
          mapForward: (strA) => {
            const wordsA = strA.split(/\s+/);
            const wordsB = wordsA.map((word) => mapping[word] || null); // Change here
            return wordsB.join(" ");
          },
          mapBackward: (strB) => {
            const wordsB = strB.split(/\s+/);
            const wordsA = wordsB.map((word) => reverseMapping[word] || word);
            return wordsA.join(" ");
          },
        };
    }

    public CSPBFMapping(input: string): string {

        if (!input) return null;

        const a = {
            'Monthly': '1',
            'Annual': 'Y',
            'Triennial': 'T',
            'Biennial': 'B',
            'One Time': '0'
        };
        const mapper = this.createWordMapper(a);
        return mapper.mapForward(input) ? mapper.mapForward(input) : mapper.mapBackward(input);
    }

    public CSPTermMapping(input: string): string {

        if (!input) return null;

        const a = {
            'P1M': 'Monthly',
            'P1Y': 'Annual',
            'P3Y': 'Triennial'
        };
        const mapper = this.createWordMapper(a);
        return mapper.mapForward(input) ? mapper.mapForward(input) : mapper.mapBackward(input);
    }

    public compare(a: number | string, b: number | string, isAsc: boolean) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }
      
}
